import Image1 from '../../assets/testimonial.png'
import Image2 from '../../assets/testimonial.png'
import Image3 from '../../assets/testimonial.png'

export const Data = [
    {
        id: 1,
        image: Image1,
        title: "Atul Velu",
        description:
            "Exceptional work, every aspect of the project was carefully managed with impressive outcomes.",
    },
    {
        id: 2,
        image: Image2,
        title: "Rahul Pawar",
        description:
            "Delivered outstanding results, the project was executed meticulously, achieving all requirements seamlessly.",
    },
    {
        id: 3,
        image: Image3,
        title: "Darshan Wagh",
        description:
            "The project was managed with great attention to detail, ensuring high quality and excellent results at every stage.",
    },
];
